import { render, staticRenderFns } from "./Page3.vue?vue&type=template&id=74aa307c&scoped=true&"
import script from "./Page3.vue?vue&type=script&lang=js&"
export * from "./Page3.vue?vue&type=script&lang=js&"
import style0 from "./Page3.vue?vue&type=style&index=0&id=74aa307c&prod&lang=scss&"
import style1 from "./Page3.vue?vue&type=style&index=1&id=74aa307c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aa307c",
  null
  
)

export default component.exports